<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
            ajax-path="whmcs/products"
        />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                refreshTable: false,
                tableIsLoading: false,
                tableLoadingText: false,
                columns: [
                    {
                        title: 'Name',
                        field: 'name',
                        sorter: 'string',
                        minWidth: 300,
                    },
                    {
                        title: 'Description',
                        field: 'description',
                        sorter: 'string',
                        minWidth: 400,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        }
                    },
                    {
                        title: 'Pricing (Monthly)',
                        field: 'pricing',
                        sorter: 'string',
                        minWidth: 100,
                        formatter({_cell}) {
                            return `AUD ${_cell.value.AUD.monthly}`;
                        }
                    },
                    {
                        title: 'Pricing (Annually)',
                        field: 'pricing',
                        sorter: 'string',
                        minWidth: 100,
                        formatter({_cell}) {
                            return `AUD ${_cell.value.AUD.annually}`;
                        }
                    },
                ],
                actions: [

                ],
            }
        }
    }
</script>